import { render } from "./Edit.vue?vue&type=template&id=06f58dce"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "06f58dce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06f58dce', script)) {
    api.reload('06f58dce', script)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=06f58dce", () => {
    api.rerender('06f58dce', render)
  })

}

script.__file = "resources/js/Pages/Station/Edit.vue"

export default script